import { Fab, Typography } from "@mui/material";
import React from "react";
import { Translate } from "orion-components/i18n";
import { Refresh } from "@mui/icons-material";

const styles = {
	wrapper: {
		display: "flex",
		alignItems: "center",
		flex: "auto",
		flexDirection: "column",
		justifyContent: "center",
		padding: "2.5%",
		zIndex: 1901,
		fontSize: 14
	},
	button: {
		zIndex: 99,
		marginTop: 12
	},
	refresh: { color: "#FFF" }
};
const StreamFailed = ({ retryStream, message }) => {
	return (
		<div className="camera-text-wrapper" style={styles.wrapper}>
			<Typography align="center" variant="subtitle1" style={{ fontSize: "1em" }}>
				{message ? message : <Translate value="global.CBComponents.video.webRTCPlayer.camProblem" />}
			</Typography>
			<Fab style={styles.button} color="primary" onClick={retryStream} size="small">
				<Refresh style={styles.refresh} />
			</Fab>
		</div>
	);
};

export default StreamFailed;
